(function () {
  var config = window.NOXTheme || {};
  var routes = config.routes || {};
  var customerId = config.customerId || "guest";
  var wishlistKey = "nox_wishlist_" + customerId;
  var wishlistDataKey = wishlistKey + "_data";

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey)) || [];
    } catch (error) {
      return [];
    }
  }

  function setWishlist(handles) {
    localStorage.setItem(wishlistKey, JSON.stringify(handles));
    updateWishlistUI();
  }

  function getWishlistData() {
    try {
      return JSON.parse(localStorage.getItem(wishlistDataKey)) || {};
    } catch (error) {
      return {};
    }
  }

  function setWishlistData(data) {
    localStorage.setItem(wishlistDataKey, JSON.stringify(data));
  }

  function updateWishlistUI() {
    var handles = getWishlist();
    qsa("[data-wishlist-button]").forEach(function (button) {
      button.classList.toggle("is-active", handles.indexOf(button.dataset.productHandle) !== -1);
    });
    qsa("[data-wishlist-count]").forEach(function (node) {
      node.textContent = handles.length;
    });
  }

  function initWishlist() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-wishlist-button]");
      if (!button) return;
      event.preventDefault();

      var handle = button.dataset.productHandle;
      var handles = getWishlist();
      var data = getWishlistData();
      var index = handles.indexOf(handle);

      if (index === -1) {
        handles.push(handle);
        data[handle] = {
          title: button.dataset.productTitle,
          url: button.dataset.productUrl
        };
      } else {
        handles.splice(index, 1);
        delete data[handle];
      }

      setWishlistData(data);
      setWishlist(handles);
      renderWishlistPage();
    });

    updateWishlistUI();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    var container = qs("[data-wishlist-grid]");
    if (!container) return;
    var handles = getWishlist();
    var data = getWishlistData();
    container.innerHTML = "";

    handles.forEach(function (handle) {
      var item = data[handle] || { title: handle, url: "/products/" + handle };
      var article = document.createElement("article");
      article.className = "product-card";
      article.innerHTML =
        '<div class="product-card__body">' +
        '<div class="product-card__topline"><span>Wishlist</span></div>' +
        '<h3 class="product-card__title"><a href="' + item.url + '">' + item.title + '</a></h3>' +
        '<div class="product-card__meta">Saved for this customer login on this browser.</div>' +
        '<div class="product-card__footer"><a class="button" href="' + item.url + '">View product</a></div>' +
        "</div>";
      container.appendChild(article);
    });
  }

  function openCartDrawer() {
    var drawer = qs("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeCartDrawer() {
    var drawer = qs("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function renderCart(cart) {
    qsa("[data-cart-count]").forEach(function (node) {
      node.textContent = cart.item_count;
    });

    var itemsContainer = qs("[data-cart-items]");
    var totalContainer = qs("[data-cart-total]");
    var emptyContainer = qs("[data-cart-empty]");
    if (!itemsContainer || !totalContainer) return;

    totalContainer.textContent = money(cart.total_price);
    itemsContainer.innerHTML = "";
    if (emptyContainer) emptyContainer.hidden = cart.item_count > 0;

    cart.items.forEach(function (item, index) {
      var row = document.createElement("div");
      row.className = "cart-item";
      row.innerHTML =
        '<a href="' + item.url + '">' +
        (item.image ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, "&quot;") + '">' : "") +
        '</a><div><a class="cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : "") +
        '<div class="cart-item__variant">' + money(item.final_line_price) + '</div>' +
        '<div class="quantity" data-line="' + (index + 1) + '">' +
        '<button type="button" data-cart-qty="' + (item.quantity - 1) + '">-</button>' +
        '<input value="' + item.quantity + '" inputmode="numeric" aria-label="Quantity">' +
        '<button type="button" data-cart-qty="' + (item.quantity + 1) + '">+</button>' +
        '</div></div>';
      itemsContainer.appendChild(row);
    });
  }

  function refreshCart(openDrawer) {
    return fetch((routes.cart_url || "/cart") + ".js", { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (openDrawer) openCartDrawer();
        return cart;
      });
  }

  function initCart() {
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-cart-open]")) {
        event.preventDefault();
        refreshCart(true);
      }
      if (event.target.closest("[data-cart-close]")) {
        event.preventDefault();
        closeCartDrawer();
      }

      var qtyButton = event.target.closest("[data-cart-qty]");
      if (qtyButton) {
        var quantity = Number(qtyButton.dataset.cartQty);
        var line = Number(qtyButton.closest("[data-line]").dataset.line);
        fetch((routes.cart_change_url || "/cart/change") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ line: line, quantity: Math.max(quantity, 0) })
        }).then(function (response) { return response.json(); }).then(function (cart) {
          renderCart(cart);
        });
      }
    });

    document.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-ajax-cart-form]");
      if (!form) return;
      event.preventDefault();
      var submit = qs("button[type='submit']", form);
      if (submit) submit.disabled = true;

      fetch((routes.cart_add_url || "/cart/add") + ".js", {
        method: "POST",
        credentials: "same-origin",
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart add failed");
          return response.json();
        })
        .then(function () { return refreshCart(true); })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function initMobileMenu() {
    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-mobile-menu-toggle]");
      if (!toggle) return;
      var panel = qs("[data-mobile-panel]");
      if (!panel) return;
      var isOpen = panel.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  function initVehicleFinder() {
    qsa("[data-vehicle-finder]").forEach(function (form) {
      var make = qs("[data-finder-make]", form);
      var model = qs("[data-finder-model]", form);
      var year = qs("[data-finder-year]", form);
      if (!make || !model || !year) return;

      function fillModels() {
        var selected = make.options[make.selectedIndex];
        var models = [];
        try {
          models = JSON.parse(selected.dataset.models || "[]");
        } catch (error) {
          models = [];
        }
        model.innerHTML = '<option value="">Select Model</option>';
        models.forEach(function (modelName) {
          var option = document.createElement("option");
          option.value = modelName;
          option.textContent = modelName;
          model.appendChild(option);
        });
      }

      make.addEventListener("change", fillModels);
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var parts = [make.value, model.value, year.value].filter(Boolean);
        var query = parts.join(" ");
        window.location.href = (routes.search_url || "/search") + "?type=product&q=" + encodeURIComponent(query);
      });
    });
  }

  function initSort() {
    qsa("[data-sort-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", select.value);
        window.location.href = url.toString();
      });
    });
  }

  function initProductGallery() {
    document.addEventListener("click", function(event) {
      var thumbnail = event.target.closest(".product-gallery__thumbnail");
      if (thumbnail) {
        var mainImage = document.querySelector('.product-gallery__main img');
        if (!mainImage) return;
        var newUrl = thumbnail.getAttribute("data-image-url");
        if (newUrl) {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = newUrl;
        }
        qsa(".product-gallery__thumbnail").forEach(function(el) {
          el.classList.remove("is-active");
        });
        thumbnail.classList.add("is-active");
      }
    });

    document.addEventListener("change", function(event) {
      var select = event.target.closest(".variant-selects select");
      if (select) {
        var mainImage = document.querySelector('.product-gallery__main img');
        if (!mainImage) return;
        var option = select.options[select.selectedIndex];
        var variantImageUrl = option.getAttribute("data-variant-image");
        if (variantImageUrl) {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = variantImageUrl;
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.documentElement.classList.remove("no-js");
    initMobileMenu();
    initCart();
    initWishlist();
    initVehicleFinder();
    initSort();
    initProductGallery();
    refreshCart(false);
  });
})();
